import React, { useState, useEffect } from "react";
import { Alert, Form, Row, Col, Button, FormFeedback, FormGroup, Label, Input, UncontrolledPopover, PopoverBody } from "reactstrap";
import { Link } from "react-router-dom";
import ConfigData from '../../../config.json';
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import SingleUploadfile from '../../common/single-uploadfile';
import MultipleUploadfile from '../../common/multiple-uploadfile';
import { getFilterOldFileName, setFormDataUploadFile, setStringFileNameToArray, setShowFileName  } from '../../utils/format-value';
// import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import { IconAlertError, IconAlertReturn } from '../../../components/common/popup-alert';
import { getDomain } from '../../utils/check-value';

const RequestFormNda = ({ dataFormNda, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const history = useHistory();
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isDisableds, setIsDisableds] = useState(false);
    const [selectedDraft, setSelectedDraft] = useState(null);
    const [dataUser, setDataUser] = useState([]);
    const [dataCompany, setDataCompany] = useState([]);
    const [selectCompany, setSelectCompany] = useState(null);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [selectLanguage, setSelectLanguage] = useState(null);
    const [selectTypeNda, setSelectTypeNda] = useState(null);
    const [dataConfidential, setDataConfidential] = useState([]);
    const [selectConfidential, setSelectConfidential] = useState(null);
    const [ddlTypeNda, setDdlTypeNda] = useState([]);
    const [InputIdIsSla, setInputIdIsSla] = useState(true);
    const [AttachDraft, setAttachDraft] = useState(false);
    const [selectedRadioPdpa, setSelectedRadioPdpa] = useState("");
    const [beginningDate, setBeginningDate] = useState(null);
    const [fileDraftAgreementDoc, setFileDraftAgreementDoc] = useState([]);
    const [fileConsiderDoc, setFileConsiderDoc] = useState([]);
    const [fileNameDraftDoc, setFileNameDraftDoc] = useState("");
    const [fileNameConsiderDoc, setFileNameConsiderDoc] = useState("");
    const [dataDetail, setDataDetail] = useState([]);
    const [emailLegalAuthorized , setEmailLegalAuthorized] = useState([]);
    const [emailLegalAdmin , setEmailLegalAdmin] = useState([]);
    const [ddlDraft, setDdlDraft] = useState([]);
    const [formTemp, setFormTemp] = useState({});

    // State to manage the checkbox's checked status
    const [isCheckedCompanyOther, setIsCheckedCompanyOther] = useState(false);
    const [companyDisabled, setCompanyDisabled] = useState(false);
    const [otherCompanyDisabled, setOtherCompanyDisabled] = useState(true);
    const [companyPlaceholder, setCompanyPlaceholder] = useState("ระบุชื่อในการทำสัญญา");
    const [otherCompanyPlaceholder, setOtherCompanyPlaceholder] = useState("");

    // const [beginningDateDisabled, setBeginningDateDisabled] = useState(false);
    
    const [showCommentApprover, setShowCommentApprover] = useState(false);
    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const autoCompletes = "on";
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // Thailand is UTC+7
    const thaiTimezoneOffset = 7 * 60; 
    const offsetInMilliseconds = thaiTimezoneOffset * 60 * 1000;
    const thaiDateTime = new Date(new Date().getTime() + offsetInMilliseconds);
    // Format the date for MySQL DATETIME
    const newDateTime = thaiDateTime.toISOString().slice(0, 19).replace("T", " ");
    // Function to handle checkbox state changes
    const handleCheckboxChangeCompanyOther = () => {
        const isChecked = !isCheckedCompanyOther; // Toggle the state
        setIsCheckedCompanyOther(isChecked);
    
        // Update states based on checkbox status
        setCompanyDisabled(isChecked);
        setOtherCompanyDisabled(!isChecked);
        setCompanyPlaceholder(isChecked ? "" : "โปรดเลือก...");
        setOtherCompanyPlaceholder(isChecked ? "กรอกชื่อบริษัท" : "");
        setSelectCompany("");
    
        // Reset form fields
        resetValidationFields(isChecked);
    };
    
    // Utility function to reset validation fields
    const resetValidationFields = (isChecked) => {
        validation.setFieldValue("id_business_unit", isChecked ? "-1" : "");
        validation.setFieldValue("business_unit_other", "");
        validation.setFieldError("id_business_unit", null);
        validation.setFieldError("business_unit_other", null);
        validation.setFieldTouched("id_business_unit", false);
        validation.setFieldTouched("business_unit_other", false);
    };

    const optionDdlTypeNda = [
        { value: "1", label: "BU เป็นฝ่ายเปิดเผยข้อมูล (BU as the Disclosing Party)" },
        { value: "2", label: "BU เป็นฝ่ายรับข้อมูล (BU as the Receiving Party)" },
        { value: "3", label: "ต่างฝ่ายต่างเปิดเผยและรับข้อมูล (Both Parties mutually disclose and receive information)" },
    ];

    const optionDdlDraft = [
        { value: "1", label: "ตรวจสอบสัญญา/บันทึกข้อตกลงตามแนบ (Review draft agreement as attached)" },
        { value: "2", label: "ให้ฝ่ายกฎหมายจัดทำสัญญา/บันทึกข้อตกลง (Draft agreement)" },
    ];

     // start check condition in form

     const checkAuthorizedSubmitOrApprove = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || dataFormRequest.id_workflow_status === 4
    );

    const checkAuthorizedReturn = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 4)
    );

    const checkUserIsApproverShowReturnBtn = (
        dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status !== 4
    );

    // case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return ถ้าใช้
    const checkUserCreateTicketAndApproveIsSame = ( 
        dataFormRequest.request_by !== dataFormRequest.approve_request_by
    );

    const changeButtonIsStateRequestorOrApprover = (
        (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.request_by) 
        || (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.create_request_by)
        || (dataFormRequest.id_workflow_status !== 4 && dataUser.email === dataFormRequest.approve_request_by) 
        || (dataFormNda.id === 0)
    )

    const checkShowInputUserCoordinator = (
        (getDomain(userEmail) !== "btsgroup.co.th" || dataUser.business_unit?.toLowerCase() !== "bts group holdings public company limited") 
        && (dataFormNda.id === 0 || dataFormRequest.request_no === "draft")
    );

    const checkLoadDataRequestAndForm = (
        (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status === 0) 
        || (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.request_by || dataFormRequest.id_workflow_status === 0)
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 1 && userEmail === dataFormRequest.approve_request_by) 
        || (dataFormRequest.id_workflow_status === 2 && userEmail === dataFormRequest.approve_request_by)
    );

    // end check condition in form

    useEffect(() => {
        LoadDataBusinessUnit();
        LoadDataLanguage();
        LoadDataConfidential();
        setDdlTypeNda(optionDdlTypeNda);
        LoadProfileUser(userEmail);
        LoadLegalAdmin(5); // หมายถึง กลุ่มของ user admin
        setDdlDraft(optionDdlDraft);
    }, []);

    useEffect(() => {
        if(dataFormNda.id > 0){
            let updateddataFormNda = {...dataFormNda};

            if (dataFormRequest.request_no === "draft" && dataFormRequest.id_business_unit === "-1") {
                updateddataFormNda.id_business_unit = "";
            }
            if (dataFormRequest.id_confidential_level === "0") {
                updateddataFormNda.id_confidential_level = "";
            }
            // console.log(updateddataFormNda);
            setDataDetail(updateddataFormNda);
            setFileDraftAgreementDoc(dataFormNda.draft_doc ? setStringFileNameToArray(dataFormNda.draft_doc) : []);
            setFileConsiderDoc(dataFormNda.consider_doc ? setStringFileNameToArray(dataFormNda.consider_doc) : []);
            setSelectedRadioPdpa(dataFormNda.share_pdpa ?? "");
            setBeginningDate(dataFormNda.beginning_date ?? "");
            if(dataFormRequest.request_no !== "draft" && dataFormNda.approver_comment !== ""){
                setShowCommentApprover(true);
            }
            LoadFormTempById(dataFormRequest.id_form_temp);
        }
    }, [dataFormNda, dataFormRequest]);

    useEffect(() => {
        if(dataFormNda.id > 0){
            // 1. set group requestor can edit when id workflow = 4 or draft or user groupId2 when user can approve request.
            // 2,3. set group approver can edit when id workflow = 1,2
            if( (checkLoadDataRequestAndForm) ){
                setCompanyDisabled(false);
                // setBeginningDateDisabled(
                //     (dataFormNda.beginning_date && dataFormNda.beginning_date.length > 0) ? false :
                //     (selectedTerm !== "1" && (dataFormRequest.request_no === "draft" || dataFormNda.beginning_date === null) ) ? true : false
                // );
            } else if( dataFormRequest.id_workflow_status > 4 ){
                setIsDisableds(false);
                setCompanyDisabled(false);
                // setBeginningDateDisabled(
                //     (dataFormNda.beginning_date && dataFormNda.beginning_date.length > 0) ? false :
                //     (selectedTerm !== "1" && (dataFormRequest.request_no === "draft" || dataFormNda.beginning_date === null) ) ? true : false
                // );
            } else {
                setIsDisableds(true);
                setCompanyDisabled(true);
                // setBeginningDateDisabled(true);
            }
            setSelectedDraft(ddlDraft.find(x => x.value === dataFormNda.draft_agreement) ?? "");
            setSelectLanguage(dataLanguage.find(x => x.value === dataFormNda.id_language?.toString()) ?? "");
            setSelectConfidential(dataConfidential.find(x => x.value === dataFormNda.id_confidential_level?.toString()) ?? "");
            setSelectCompany(dataCompany.find(x => x.value === dataFormNda.id_business_unit?.toString()) ?? "");
            setSelectTypeNda(optionDdlTypeNda.find(x => x.value === dataFormNda.type_of_nda?.toString()) ?? "");
            LoadLegalAuthorized(dataFormNda.id_business_unit);
        }
    }, [dataLanguage, dataConfidential, dataCompany, dataFormNda, ddlDraft ]);

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };

    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadFormTempById = (idFormTemp) =>{
        let url = ConfigData.API_URL + "form-temp/" + idFormTemp;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setFormTemp(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAuthorized = (idBusinessUnit) => {
        let url = ConfigData.API_URL + "map-user-assign/search?status=1&id_business_unit=" + idBusinessUnit;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                if(respData.data.length > 0){
                    setEmailLegalAuthorized(respData.data);
                } else {
                    // sayam@btsgroup.co.th, anchalee@btsgroup.co.th
                    setEmailLegalAuthorized([{"email": "sayam@btsgroup.co.th"},{"email": "anchalee@btsgroup.co.th"}]);
                }
                // console.log(respData.data[0].email);
            } else {
                setEmailLegalAuthorized("");
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAdmin = (groupId) => {
        let url = ConfigData.API_URL + "user/?status=1&id_user_group=" + groupId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            responseType: "json",
        })
        .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setEmailLegalAdmin(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString()
                    };
                });
                setDataCompany(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataLanguage = () => {
        let url = ConfigData.API_URL + "language/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDataLanguage(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataConfidential= () => {
        let url = ConfigData.API_URL + "confidential/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_th + " (" + e.name_en + ")",
                        value: e.id.toString(),
                    };
                });
                setDataConfidential(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const onCheckSaveDraft = () => {
        dataUser.email === dataFormRequest.approve_request_by ? setIsSaveEnabled(false) : setIsSaveEnabled(true);
        if(( dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by ) || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) || dataFormRequest.id_workflow_status === 4 || dataFormRequest.id_workflow_status === 0){
            validationDraft.submitForm();
        } else if(dataFormNda.id_request === ""){
            validationDraft.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    }

    const onCheckSubmit = async () => {
        // ทำการ validate ฟอร์มทั้งหมด
        const errors = await validation.validateForm();
    
        // ตรวจสอบว่ามี error หรือไม่
        if (Object.keys(errors).length > 0) {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                showConfirmButton: false,
                showCloseButton: true,
            });
            // return; // หยุดการทำงานถ้ามี error
        }
    
        // ถ้าไม่มี error ให้ทำการ submit form
        if (!dataFormRequest.id_workflow_status) {
            validation.submitForm();
        } else if ( checkAuthorizedSubmitOrApprove ) {
            validation.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const onCheckReturn = () => {
        // console.log("return");
        setShowCommentApprover(true);
        validationReturn.submitForm();
        // console.log(showCommentApprover);
        if(showCommentApprover === true){
            // console.log(showCommentApprover);
            if(Object.getOwnPropertyNames(validationReturn.errors).length === 0){
                if( checkAuthorizedReturn ){
                    onReturn(dataFormRequest, validation.values);
                } else {
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "You Are not authorized to action this.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            }else {
                // ถ้ามีข้อผิดพลาด แสดงข้อความเตือน
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "กรุณากรอกข้อมูลความเห็นของผู้อนุมัติ",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    }

    const onReturn = (dataRequest, dataFormNda) => {
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
    
        let isSaveSucess = true;
        (async () => {
            try{
                let dataReturn = await UpdateReturn(dataRequest.id);
                isSaveSucess = (dataReturn.is_sucess === true && isSaveSucess === true) ? true : false;
                //console.log(dataReturn);

                let str_send_to = dataRequest.request_by;

                if ( dataRequest.create_request_by && dataRequest.request_by !== dataRequest.create_request_by ) {
                    str_send_to += `,${dataRequest.create_request_by}`;
                }
                
                const dataRequestWorkFlows = {
                    "id_request": dataRequest.id,
                    "id_workflow_status" : 4,
                    "do_by" : userEmail,
                    "send_to" : str_send_to,
                    "cc_to" : null,
                    "comment" : dataFormNda.approver_comment,
                    "document" : null,
                    "consent" : null,
                    "do_date" : newDateTime,
                };
                let dataRequestWorkFlow = await AddRequestWorkFlow(dataRequestWorkFlows);
                isSaveSucess = (dataRequestWorkFlow.is_sucess === true && isSaveSucess === true) ? true : false;
                //console.log(dataRequestWorkFlow);

                if(isSaveSucess === true){
                    let isSendMail = await SendMailReturn(dataRequestWorkFlow.data[0]);
                    if( isSendMail === true ){
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                                iconHtml: IconAlertReturn,
                                title: "Return to user who request.",
                                showConfirmButton: false,
                                showCloseButton: true,
                                // showConfirmButton: false,
                            }).then(() => {
                                // props.nextStep();
                                history.push(GetUrlBack());
                            });
                    }else{
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to send email to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                }else{
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error){
                console.log(error);
            }
        })();
    };

    const UpdateReturn = async (id) => {
        let url = ConfigData.API_URL + "request/approval-return/" + id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url,{}, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateRequests = async (data) => {
        let url = ConfigData.API_URL + "request/" + data.id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const UpdateFormNda = async (data) => {
        let url = ConfigData.API_URL + "form-nda/" + data.id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url, data, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // console.log(respData);
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const AddRequestWorkFlow = async (dataRequestWorkFlows) => {
        let url = ConfigData.API_URL + "request-workflow/";
        let data = dataRequestWorkFlows;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SendMailReturn = async (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 2,
            "request_id": data.id_request,
        };
        try {
            const resp = await axios.post(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        } catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const OnSetFileAgreementDoc = (files) => {
        setIsSaveEnabled(true);
        //console.log(files);
        setFileDraftAgreementDoc(files);
        updateDraftDocNames(files);
    };

    const updateDraftDocNames = (files) => {
        setIsSaveEnabled(true);
        const names = files.map(file => file.name).join(",");
        validation.handleChange('draft_doc')(names);
        validationDraft.handleChange('draft_doc')(names);
        setFileNameDraftDoc(names);
    };

    const OnSetFileConsiderDoc = (files) => {
        setIsSaveEnabled(true);
        setFileConsiderDoc(files);
        updateConsiderDocNames(files);
    };

    const updateConsiderDocNames = (files) => {
        setIsSaveEnabled(true);
        const names = files.map(file => file.name).join(",");
        setFileNameConsiderDoc(names);
    };

    const handleRadioChangePdpa = (event) => {
        setIsSaveEnabled(true);
        // isEnabled(true);
         setSelectedRadioPdpa(event.target.value);
        if( event.target.value === "1"){
            // setInputIdForUpload({ nameInputIsSla: "isSlaDocActive" });
            setInputIdIsSla(false);
            // console.log(InputIdForUpload.nameInputIsSla);
        } else {
            // setInputIdForUpload({ nameInputIsSla: "isSlaDocInActive" });
            setInputIdIsSla(true);
            // console.log(InputIdForUpload.nameInputIsSla);
        }
        validation.handleChange("share_pdpa")(event.target.value);
        validationDraft.handleChange("share_pdpa")(event.target.value);
    };

    const handleStartDateChange = (event) => {
        setIsSaveEnabled(true);
        setBeginningDate(event.target.value);
        validation.handleChange("beginning_date")(event.target.value);  // Trigger validation
        validationDraft.handleChange("beginning_date")(event.target.value);  // Trigger validation
        // console.log(event.target.value);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_language: dataDetail.id_language || "",
            id_confidential_level: dataDetail.id_confidential_level || "",
            project_name: dataDetail.project_name || "",
            draft_agreement : dataDetail.draft_agreement || "",
            draft_doc : dataDetail.draft_doc || "",
            counterparty_name: dataDetail.counterparty_name || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            type_of_nda: dataDetail.type_of_nda || "",
            purpose: dataDetail.purpose || "",
            beginning_date: dataDetail.beginning_date || "",
            share_pdpa: dataDetail.share_pdpa || "",
            user_comment: dataDetail.user_comment || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            // require_support_docs : dataDetail.require_support_docs || "",
            // require_support_doc_other : dataDetail.require_support_doc_other || "",
            consider_doc: dataDetail.consider_doc || "",
            check_request_no: dataFormRequest?.request_no || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
        },
        validationSchema: Yup.object({
            draft_agreement: Yup.string().required("กรุณาเลือก/Please select"),
            draft_doc: Yup.string().when("draft_agreement", {
                is: (draft_agreement) => draft_agreement === "1",
                then: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            // id_business_unit: Yup.string().when("isDisabled", {
            //     is: (isDisabled) => !isDisabled,
            //     then: Yup.string().required("กรุณาเลือก/Please select"),
            //     otherwise: Yup.string().notRequired(),
            // }),
            id_business_unit: Yup.string()
            .required('กรุณาเลือก/Please select')
            .notOneOf(['0', 0, '', null], 'กรุณาเลือก/Please select'),
            business_unit_other: Yup.string().when(["id_business_unit", "isDisabled"], {
                is: (id_business_unit, isDisabled) => !isDisabled && id_business_unit === "-1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            counterparty_name: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
            type_of_nda: Yup.string().required("กรุณาเลือก/Please select"),
            purpose: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
            beginning_date: Yup.string().required("กรุณาเลือก/Please select"),
            id_language: Yup.string().required("กรุณาเลือก/Please select"),
            id_confidential_level: Yup.string().required("กรุณาเลือก/Please select"),
            share_pdpa: Yup.string().required("กรุณาเลือก/Please select"),
            require_handled_by: Yup.string().email("กรุณาระบุอีเมลนักกฎหมาย/Please provide the lawyer's email address"),
            user_comment: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
            approve_request_by: Yup.string().when("check_request_no", {
                is: (check_request_no) => check_request_no === undefined || check_request_no === "draft",
                then: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address")
                .test('is-not-current-user', 'ไม่สามารถใช้อีเมลของผู้ใช้งานปัจจุบัน/You cannot use your own email', function(value) {
                    return value?.toLowerCase() !== userEmail; 
                }),
                otherwise: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            }),
            create_request_by: !checkShowInputUserCoordinator
            ? Yup.string().nullable()
            : Yup.string()
                .required("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .email("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .matches(englishEmailRegex, "Email must be a valid English email address"),
        }),
        onSubmit: (values) => {
            values.id_workflow_status = dataFormRequest.id_workflow_status;
            values.id_language = values.id_language !== "" ? parseInt(values.id_language) : null;
            values.type_of_nda = values.type_of_nda !== "" ? parseInt(values.type_of_nda) : null;
            values.beginning_date = values.beginning_date !== "" ? values.beginning_date : null;
            values.request_no = dataFormRequest.request_no; // check request_no
            values.draft_doc = fileNameDraftDoc.toString() !== "" ? fileNameDraftDoc.toString() : values.draft_doc;
            values.consider_doc = fileNameConsiderDoc.toString() !== "" ? fileNameConsiderDoc.toString() : values.consider_doc;
            values.file_draft_doc = fileDraftAgreementDoc;
            values.file_consider_doc = fileConsiderDoc;
            values.id_business_unit = companyDisabled === true ? "-1" : values.id_business_unit;
            // values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            onSave(values);
        }
    });

    const validationDraft = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_language: dataDetail.id_language || "",
            id_confidential_level: dataDetail.id_confidential_level || "",
            project_name: dataDetail.project_name || "",
            draft_agreement : dataDetail.draft_agreement || "",
            draft_doc : dataDetail.draft_doc || "",
            counterparty_name: dataDetail.counterparty_name || "",
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            type_of_nda: dataDetail.type_of_nda || "",
            purpose: dataDetail.purpose || "",
            beginning_date: dataDetail.beginning_date || "",
            share_pdpa: dataDetail.share_pdpa || "",
            user_comment: dataDetail.user_comment || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            // require_support_docs : dataDetail.require_support_docs || "",
            // require_support_doc_other : dataDetail.require_support_doc_other || "",
            consider_doc: dataDetail.consider_doc || "",
            check_request_no: dataFormRequest?.request_no || "",
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
        },
        onSubmit: (values) => {
            values.id_workflow_status = dataFormRequest.id_workflow_status;
            values.id_language = values.id_language !== "" ? parseInt(values.id_language) : null;
            values.type_of_nda = values.type_of_nda !== "" ? parseInt(values.type_of_nda) : null;
            values.beginning_date = values.beginning_date !== "" ? values.beginning_date : null;
            values.request_no = dataFormRequest.request_no; // check request_no
            values.draft_doc = fileNameDraftDoc.toString() !== "" ? fileNameDraftDoc.toString() : values.draft_doc;
            values.consider_doc = fileNameConsiderDoc.toString() !== "" ? fileNameConsiderDoc.toString() : values.consider_doc;
            values.file_draft_doc = fileDraftAgreementDoc;
            values.file_consider_doc = fileConsiderDoc;
            values.id_business_unit = companyDisabled === true ? "-1" : (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            // values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            if(dataFormRequest?.request_no === undefined || dataFormRequest?.request_no === "draft"){
                values.approve_request_by = values.approve_request_by?.toLowerCase() === userEmail.toLowerCase() ? "" : values.approve_request_by?.toLowerCase();
            } else {
                values.approve_request_by = values.approve_request_by?.toLowerCase();
            }
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();
            onSaveDraft(values);
        }
    });

    const validationReturn = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
        },
        validationSchema: Yup.object({
            // approver_comment: Yup.string().when('showCommentApprover', {
            //     is: false,
            //     then: Yup.string().required('Please enter a Comment.'),
            //     otherwise: Yup.string(),
            // }),
            approver_comment: Yup.string().trim().required("กรุณาระบุความเห็นเพิ่มเติม"),
        }),
        onSubmit: (values) => {
            //console.log(values);
        }
    });

    return (
        <React.Fragment>
            <div id="form-request" className="form-request-memo">
            <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            validationDraft.handleSubmit();
                            validationReturn.handleSubmit();
                            return false;
                        }}
                    >
                <div id="section-page-1-2">
                    <Col xl={12} className="mx-auto">
                        <div>​
                            <span className="span-title">ข้อมูลทั่วไป (Request General Information)</span>
                        </div><br/>
                    </Col>
                </div>
                <div id="section-page-2-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                    <Input
                                    type="text"
                                    name="typeOfRequest"
                                    value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                    // onChange={onInputChanged}
                                    disabled
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">เรื่อง (Matters)</Label>
                                    <Input
                                    type="text"
                                    name="typeOfContract"
                                    value={dataFormRequest.name_en_sub_request_type ? dataFormRequest.name_en_sub_request_type || "" : formTemp.name_en_sub_request_type || ""}
                                    // onChange={onInputChanged}
                                    disabled
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-3-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title" htmlFor="txtProjectName">ชื่อโครงการ (Project Name (if any))</Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightProjectName"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightProjectName" >
                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากเอกสารหรือสัญญาที่ต้องการให้ฝ่ายกฎหมายร่างหรือตรวจสอบมีความเกี่ยวข้องกับโครงการ (Project) ใด โปรดระบุเพิ่มเติม<br/>If such document is in relation to any project, please specify.</PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Input 
                                        id="txtProjectName" 
                                        name="project_name"
                                        autoComplete={autoCompletes}
                                        className="txt-placeholder"
                                        placeholder="ระบุชื่อโครงการ(ถ้ามี)"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.project_name || ""}
                                        disabled={isDisableds}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                <Label className="label-title">ต้องการให้ฝ่ายกฎหมายดำเนินการ (Request Legal Team to)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRight"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRight" >
                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากเป็นกรณีแก้ไขเปลี่ยนแปลงรายละเอียดของสัญญาเดิม ขอให้แนบสัญญาเดิมประกอบมาด้วย<br/>In case of amendment of the existing agreement, please attach the existing agreement file.</PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Select
                                        id="ddlDraft" 
                                        name="draft_agreement"
                                        value={selectedDraft}
                                        className="txt-placeholder"
                                        placeholder={"เลือกความต้องการในการดำเนินการ"}
                                        onChange={(selected) => {
                                            setSelectedDraft(selected);
                                            const selectedValue = (selected !== null) ? selected.value : "";
                                            validation.handleChange("draft_agreement")((selected !== null) ? selected.value : "");
                                            validationDraft.handleChange("draft_agreement")((selected !== null) ? selected.value : "");
                                            setIsSaveEnabled(true);
                                            if( selectedValue === "1"){
                                                setAttachDraft(true);
                                            } else {
                                                setFileNameDraftDoc("");
                                                setAttachDraft(false);
                                                setFileDraftAgreementDoc([]);
                                                //validation.setFieldValue("draft_doc", "");
                                            }
                                        }}
                                        options={ddlDraft}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.draft_agreement && validation.errors.draft_agreement ? true : false }
                                        isDisabled={isDisableds}
                                    />
                                    { validation.touched.draft_agreement && validation.errors.draft_agreement ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.draft_agreement}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                    { AttachDraft === true && (
                                        <Label>กรุณาแนบไฟล์ Draft Agreement<span className="msg-require">*</span></Label>
                                    )}
                                    <MultipleUploadfile inputID="draftDoc" folder={dataFormRequest.request_no} dataFile={fileDraftAgreementDoc} setDataFile={OnSetFileAgreementDoc} isDisable={validation.values.draft_agreement !== "1" || isDisableds} />
                                    { validation.touched.draft_doc && validation.errors.draft_doc ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.draft_doc}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-4-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCompanyName"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="PopoverRightCompanyName">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุว่าจะเข้าทำสัญญาในนามของบริษัทในเครือรายใด หาก user ต้องการระบุชื่อบริษัทที่ไม่มีในรายชื่อบริษัท โปรดเลือก Others และกรอกชื่อบริษัทดังกล่าว<br/>Please indicate the company or affiliate name who is the party. If the party is not listed here, please select 'Others' and provide such company's name.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">ทำสัญญาในนามของ (Company Name)<span className="msg-require">*</span></Label>
                                <Select id="ddlBusinessUnit"
                                    name="id_business_unit"
                                    value={selectCompany}
                                    className="txt-placeholder"
                                    placeholder={companyPlaceholder}
                                    onChange={(selected) => {
                                        setSelectCompany(selected);
                                        validation.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                        // handleSelectChangeCompany(selected);
                                        setIsSaveEnabled(true);
                                        if (selected && selected.value) {
                                            LoadLegalAuthorized(selected.value);
                                        }
                                    }}
                                    options={dataCompany}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                    isDisabled={companyDisabled} // Set disabled based on the variable
                                />
                                { validation.touched.id_business_unit && validation.errors.id_business_unit ? 
                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_business_unit}</FormFeedback> ) : false 
                                }
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Input
                                        type="checkbox"
                                        name="checkbox_business_unit_other"
                                        checked={isCheckedCompanyOther}
                                        onChange={handleCheckboxChangeCompanyOther}
                                        disabled={isDisableds}
                                        />
                                    <Label className="label-title"> อื่นๆ (Others)</Label>
                                    <Input
                                    type="text"
                                    name="business_unit_other"
                                    className="txt-placeholder"
                                    autoComplete={autoCompletes}
                                    placeholder={otherCompanyPlaceholder}
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={otherCompanyDisabled === true ? "" : validation.values.business_unit_other || ""}
                                    invalid={validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false}
                                    disabled={otherCompanyDisabled}
                                    />
                                    {validation.touched.business_unit_other && validation.errors.business_unit_other ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.business_unit_other}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-5-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ประเภท NDA (Type of NDA) <span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightSelectNda"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightSelectNda" >
                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุว่าภายใต้สัญญานี้ฝ่ายใดเป็นผู้เปิดเผยข้อมูลหรือมีการเปิดเผยข้อมูลทั้งสองฝ่าย<br/>Please specify who will disclose information under this agreement.</PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    <Select id="ddlTypeNda"
                                        name="type_of_nda"
                                        value={selectTypeNda}
                                        className="txt-placeholder"
                                        placeholder={"เลือกประเภท"}
                                        onChange={(selected) => {
                                            setSelectTypeNda(selected);
                                            validation.handleChange("type_of_nda")((selected !== null) ? selected.value : "");
                                            validationDraft.handleChange("type_of_nda")((selected !== null) ? selected.value : "");
                                            setIsSaveEnabled(true);
                                        }}
                                        options={ddlTypeNda}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.type_of_nda && validation.errors.type_of_nda ? true : false }
                                        isDisabled={isDisableds}
                                    />
                                    { validation.touched.type_of_nda && validation.errors.type_of_nda ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.type_of_nda}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Label className="label-title">ชื่อคู่สัญญาอีกฝ่าย (Counterparty's Name) <span className="msg-require">*</span></Label>
                                    <Input
                                        type="text"
                                        name="counterparty_name"
                                        autoComplete={autoCompletes}
                                        className="txt-placeholder"
                                        placeholder="ระบุชื่อคู่สัญญาอีกฝ่าย"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.counterparty_name || ""}
                                        invalid={validation.touched.counterparty_name && validation.errors.counterparty_name ? true : false}
                                        disabled={isDisableds}
                                        />
                                        {validation.touched.counterparty_name && validation.errors.counterparty_name ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.counterparty_name}
                                        </FormFeedback>
                                        ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-6-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">วัตถุประสงค์ของการเปิดเผยข้อมูล (Purpose)<span className="msg-require">*</span></Label>
                                    <Label className="label-title-purpose">ขอให้ระบุรายละเอียดอย่างย่อของสัญญาว่าเป็นเรื่องเกี่ยวกับอะไร เช่น สัญญาจ้างบริหารจัดการด้านบัญชี/ การตลาด, สัญญาเช่ารถยนต์ ทะเบียนเลขที่ x-xxx, สัญญาจ้างเหมาทำความสะอาด อาคาร xx, สัญญาซื้อขายพร้อมติดตั้งลิฟท์, สัญญาให้บริการซอฟท์แวร์ xxxx เป็นต้น โดยห้ามระบุว่า ’ตามเอกสารแนบ’ หรือคำอื่นใดที่ไม่แสดงให้ทราบได้ว่า เป็นสัญญาเกี่ยวกับเรื่องอะไร มิฉะนั้น ฝ่ายกฎหมายขอสงวนสิทธิ์กด Reject งานนั้น</Label>
                                    <Input
                                        type="textarea"
                                        name="purpose"
                                        autoComplete={autoCompletes}
                                        className="txt-placeholder txt-text-area"
                                        placeholder="ระบุรายละเอียดอย่างย่อของสัญญาว่าเป็นเรื่องเกี่ยวกับอะไรให้ชัดเจน"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.purpose || ""}
                                        invalid={validation.touched.purpose && validation.errors.purpose ? true : false}
                                        disabled={isDisableds}
                                        />
                                        {validation.touched.purpose && validation.errors.purpose ? (
                                        <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                            {validation.errors.purpose}
                                        </FormFeedback>
                                        ) : false}
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>    
                                    <Label className="label-title">เริ่มเปิดเผย/รับข้อมูลวันที่ (Beginning Date of Information Disclosure)<span className="msg-require">*</span></Label>
                                    <Input
                                        type="date"
                                        // min={new Date().toISOString().split('T')[0]}
                                        id="beginningDate"
                                        name="beginning_date"
                                        className="form-control"
                                        value={beginningDate || ""}
                                        invalid={validation.touched.beginning_date && validation.errors.beginning_date ? true : false}
                                        onChange={handleStartDateChange}
                                        disabled={isDisableds}
                                    />
                                    {validation.touched.beginning_date && validation.errors.beginning_date ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.beginning_date}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-7-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={3}>
                                <FormGroup>
                                    <Label className="label-title">ภาษา (Language)<span className="msg-require">*</span></Label>
                                    <Select id="ddlLanguage"
                                        name="id_language"
                                        value={selectLanguage}
                                        className="txt-placeholder"
                                        placeholder={"เลือกภาษา"}
                                        onChange={(selected) => {
                                            setSelectLanguage(selected);
                                            validation.handleChange("id_language")((selected !== null) ? selected.value : "");
                                            validationDraft.handleChange("id_language")((selected !== null) ? selected.value : "");
                                            setIsSaveEnabled(true);
                                        }}
                                        options={dataLanguage}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_language && validation.errors.id_language ? true : false }
                                        isDisabled={isDisableds}
                                    />
                                    { validation.touched.id_language && validation.errors.id_language ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_language}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={7}>
                                <FormGroup>
                                <Label className="label-title-confidential">ระดับชั้นความลับ (Confidentiality Level)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightConfidential"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="PopoverRightConfidential" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i>"ทั่วไป" หมายถึง สามารถเปิดเผยให้ฝ่ายกฎหมายและผู้ที่เกี่ยวข้องได้<br/>"เป็นความลับ" หมายถึง เอกสารนี้จะเปิดเผยให้แก่ฝ่ายกฎหมายที่ถูกระบุชื่อและฝ่ายกฎหมายระดับ Associate Director ขึ้นไปเท่านั้น​<br/>"General" means that this request will be shared with all legal team members and related persons<br/>"Confidentiality" means that this request will be shared with the specified legal person and legal associate directors or higher level. ​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Select id="ddlConfidential"
                                    name="id_confidential_level"
                                    value={selectConfidential}
                                    className="txt-placeholder"
                                    placeholder={"เลือกระดับความลับของเอกสาร"}
                                    onChange={(selected) => {
                                        setSelectConfidential(selected);
                                        validation.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                        validationDraft.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                        setIsSaveEnabled(true);
                                    }}
                                    options={dataConfidential}
                                    isClearable={true}
                                    isSearchable={true}
                                    invalid={ validation.touched.id_confidential_level && validation.errors.id_confidential_level ? true : false }
                                    isDisabled={isDisableds}
                                />
                                { validation.touched.id_confidential_level && validation.errors.id_confidential_level ? 
                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_confidential_level}</FormFeedback> ) : false 
                                }
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-8-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title">มีการเปิดเผย/ใช้/ประมวลผลข้อมูลส่วนบุคคลภายใต้เอกสารนี้หรือไม่ <br/>(Personal data will be disclosed/used/processed under this document)<span className="msg-require">*</span>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightSharedPdpa"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="right" target="PopoverRightSharedPdpa" >
                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i>ข้อมูลส่วนบุคคลคือข้อมูลที่สามารถระบุตัวบุคคลใดได้ไม่ว่าทางตรงหรือทางอ้อม<br/>Personal Information is any information relating to a person, which enables the identification of such person, whether directly or indirectly.​</PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    </Label>
                                    <div className="mt-4 mt-lg-0 label-ddl">
                                        <div className="form-check form-check-inline">
                                            <Input
                                            className="form-check-input"
                                            type="radio"
                                            name="share_pdpa"
                                            id="inlineRadioPdpa1"
                                            value="1"
                                            checked={selectedRadioPdpa === "1"}
                                            onChange={handleRadioChangePdpa}
                                            invalid={ validation.touched.share_pdpa && validation.errors.share_pdpa ? true : false }
                                            disabled={isDisableds}
                                            />
                                            <Label className="form-check-label" htmlFor="inlineRadioPdpa1">
                                            Yes (This request will be shared with PDPA team)
                                            </Label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <Input
                                            className="form-check-input"
                                            type="radio"
                                            name="share_pdpa"
                                            id="inlineRadioPdpa2"
                                            value="0"
                                            checked={selectedRadioPdpa === "0"}
                                            onChange={handleRadioChangePdpa}
                                            invalid={ validation.touched.share_pdpa && validation.errors.share_pdpa ? true : false }
                                            disabled={isDisableds}
                                            />
                                            <Label className="form-check-label" htmlFor="inlineRadioPdpa2">
                                            No
                                            </Label>
                                        </div>
                                    </div>
                                    {validation.touched.share_pdpa && validation.errors.share_pdpa ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }}>
                                        {validation.errors.share_pdpa}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverTopUserComment"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="PopoverTopUserComment">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> กรุณาระบุว่าจากการตรวจสอบของ User แล้ว User มีความเห็นเพิ่มเติมในเอกสาร/สัญญาดังกล่าวอย่างไรบ้าง<br/>Please specify if the user has any comments on the documents / agreements.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">ความเห็นของ User (User's Comment)<span className="msg-require">*</span></Label>
                                <Input
                                    type="text"
                                    id="txtUserComment"
                                    name="user_comment"
                                    autoComplete={autoCompletes}
                                    className="txt-placeholder"
                                    placeholder="ระบุว่ามีความเห็นเพิ่มเติมในเอกสาร/สัญญาดังกล่าวอย่างไร"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.user_comment || ""}
                                    invalid={validation.touched.user_comment && validation.errors.user_comment ? true : false}
                                    disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.approve_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                                    />
                                    {validation.touched.user_comment && validation.errors.user_comment ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.user_comment}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </div>
                <div id="section-page-9-1">
                    <Col md={12} className="mx-auto">
                        <Row>
                            <Col md={10}>
                                <Label className="label-title">เอกสารแนบเพื่อพิจารณา (Attachment)</Label>
                                <FormGroup>
                                    {/* <Label>กรุณาแนบไฟล์ Draft Agreement<span className="msg-require">*</span></Label> */}
                                    <MultipleUploadfile inputID="consider_doc" folder={dataFormRequest.request_no} dataFile={fileConsiderDoc} setDataFile={OnSetFileConsiderDoc} isDisable={isDisableds} />
                                    { validation.touched.consider_doc && validation.errors.consider_doc ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.consider_doc}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverTopLegalHandle"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="PopoverTopLegalHandle">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (ขั้นตอนนี้ไม่ใช่การกำหนดเลือกคนทำงาน ฝ่ายกฎหมายขอสงวนสิทธิ์ในการกำหนดคนทำงานนี้ต่อไป)<br/>This request will be sent to the e-mail address of the e-mail person. (This step is not to select workers. The Legal Department reserves the right to solely decide and assign people to do this work.)</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">นักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled this work)</Label>
                                <Input 
                                    id="txtRequireHandledBy" 
                                    name="require_handled_by"
                                    autoComplete={autoCompletes}
                                    className="txt-placeholder"
                                    placeholder="กรุณาระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.require_handled_by || ""}
                                    invalid={validation.touched.require_handled_by && validation.errors.require_handled_by ? true : false}
                                    disabled={dataFormRequest.id_workflow_status > 4 ? true : isDisableds}
                                />
                                {validation.touched.require_handled_by && validation.errors.require_handled_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.require_handled_by}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12}>
                        <div className="line-border"></div>
                    </Col>
                    <Col xl={12} className="mx-auto">
                        <div>
                            <span className="span-title">User Approval Process</span>
                        </div><br/>
                    </Col>
                </div>
                <div id="section-page-10-1">
                    <Col md={10}>
                        <FormGroup>
                        <Label className="label-title">ผู้อนุมัติแบบคำขอ (User Approver)<span className="msg-require">*</span>
                        </Label>
                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightApproval"></i>
                        <div className="hstack flex-wrap gap-2">
                            <UncontrolledPopover placement="right" target="PopoverRightApproval" >
                                <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุชื่อผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ <br/>(Please specify the approver's name. Kindly note that all requests must be approved by director or higher level in your function.)​</PopoverBody>
                            </UncontrolledPopover>
                        </div>
                        <Input
                            type="text"
                            id="txtApproveRequestBy"
                            name="approve_request_by"
                            autoComplete={autoCompletes}
                            className="txt-placeholder"
                            placeholder="กรุณากรอกอีเมล"
                            onChange={(e) => {
                                validation.handleChange(e);
                                validationDraft.handleChange(e);
                                // console.log(e.target.value);
                                setIsSaveEnabled(true); // Set save enabled to true when the input changes
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.approve_request_by || ""}
                            invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                            disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.approve_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                        />
                            {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                            <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                {validation.errors.approve_request_by}
                            </FormFeedback>
                            ) : false}
                        
                        </FormGroup>
                    </Col>
                    { checkShowInputUserCoordinator ? (
                    <Col md={10}>
                        <FormGroup>
                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCoodinator"></i>
                        <div className="hstack flex-wrap gap-2">
                            <UncontrolledPopover placement="right" target="PopoverRightCoodinator">
                                <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุอีเมลของผู้ประสานงานสำหรับคำขอนี้โดยจะต้องเป็นผู้ที่มีรายชื่อเป็นผู้ประสานงานตามที่บริษัทกำหนดและได้แจ้งฝ่ายกฎหมาย BTSG ไว้แล้ว <br/>Please specify the email address of the coordinator for this request. The specified person must be listed as a coordinator as designated by the company and has been informed to BTSG legal team.</PopoverBody>
                            </UncontrolledPopover>
                        </div>
                        <Label className="label-title">ชื่อผู้ประสานงาน (Name of User Coordinator)<span className="msg-require">*</span></Label>
                        <Input
                            type="text"
                            id="txtCreateRequestBy"
                            name="create_request_by"
                            autoComplete={autoCompletes}
                            className="txt-placeholder"
                            placeholder="กรอกอีเมลผู้ประสานงาน"
                            onChange={(e) => {
                                validation.handleChange(e);
                                validationDraft.handleChange(e);
                                // console.log(e.target.value);
                                setIsSaveEnabled(true); // Set save enabled to true when the input changes
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.create_request_by || ""}
                            invalid={validation.touched.create_request_by && validation.errors.create_request_by ? true : false}
                            disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                        />
                            {validation.touched.create_request_by && validation.errors.create_request_by ? (
                            <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                {validation.errors.create_request_by}
                            </FormFeedback>
                            ) : false}
                        
                        </FormGroup>
                    </Col>
                    ):""}
                    { showCommentApprover === true || Boolean(dataFormNda.approver_comment && dataFormNda.approver_comment !== "") ? (
                        <>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                        <Col md={10}>
                            <div className="page-content-approver">
                                <div className="approver-header-content">
                                {dataUser.email === dataFormRequest.approve_request_by ? "ระบุความเห็นเพื่อส่งไปยังผู้ร้องขอ (Please specify comments to send to the requester.)" : "คุณมีความเห็นจากผู้อนุมัติ (You have a comments from the approver)"}
                                </div>
                                <FormGroup>
                                <Col md={10} className="approver-col">
                                    <Label className="label-title-approver-comment">ความเห็นของผู้อนุมัติ (Approver's Comment)</Label>
                                    <Input
                                        type="text"
                                        id="txtApproveComment"
                                        name="approver_comment"
                                        autoComplete={autoCompletes}
                                        className="txt-approver-comment"
                                        placeholder="ความเห็นเพิ่มเติมของผู้อนุมัติ"
                                        onChange={(e) => {
                                            validation.handleChange(e);
                                            validationDraft.handleChange(e);
                                            validationReturn.handleChange(e);
                                            //setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                        }}
                                        onBlur={validationReturn.handleBlur}
                                        value={validation.values.approver_comment || ""}
                                        invalid={validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? true : false}
                                        disabled={(dataUser.email === dataFormRequest.request_by) || (dataUser.email === dataFormRequest.create_request_by) || (dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status === 4) ? true : false}
                                    />
                                    {validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? (
                                    <FormFeedback type="invalid" className="alert-validation-approver-comment">
                                        {validationReturn.errors.approver_comment}
                                    </FormFeedback>
                                    ) : false}
                                </Col>
                                </FormGroup>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="line-border"></div>
                        </Col>
                        </>
                    ):null}
                </div>
                <br/>
                {   
                    dataFormRequest.id_workflow_status >= 0 && // Check if status is 0 or greater
                    dataFormRequest.id_workflow_status <= 4 ||
                    dataFormNda.id === 0 ? (
                    <Row>
                        <div className="page-footer">
                            <div className="layout-width-footer">
                                <div className="navbar-footer">
                                    <>
                                    <div className="d-flex align-items-center">
                                        <Link to={GetUrlBack()} className="logo">
                                            <Button 
                                                color="outline secondary" 
                                                type="button" 
                                                // onClick={handleBack}
                                            >
                                            Back
                                            </Button>
                                        </Link>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        {dataFormRequest.request_no === "draft" ? (
                                            <Button 
                                                color="outline secondary" 
                                                type="button" 
                                                // onClick={handleBack}
                                                onClick={() => onCancelRequest(dataFormRequest)}
                                            >
                                            Delete
                                            </Button>
                                        ): null}
                                        {checkUserIsApproverShowReturnBtn ?(
                                            <>
                                            {/* case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return  */}
                                            {checkUserCreateTicketAndApproveIsSame ?(
                                            <Button 
                                            className="btn-return-style"
                                            color="outline secondary" 
                                            type="button" 
                                            disabled={isSaveEnabled}
                                            onClick={() => onCheckReturn()}
                                            >
                                                Return
                                            </Button>
                                            ):null}
                                            </>
                                        ):null}
                                        {(changeButtonIsStateRequestorOrApprover) ?(
                                            <>
                                                <Button 
                                                    className="float-end btn-save-style"  
                                                    color={isSaveEnabled ? "primary" : "secondary"} 
                                                    outline 
                                                    type="button" 
                                                    disabled={!isSaveEnabled}
                                                    onClick={() => onCheckSaveDraft()}
                                                >
                                                    Save
                                                </Button>
                                                <Button 
                                                    className="float-end btn-submit-style" 
                                                    color="primary" 
                                                    type="button"
                                                    disabled={dataUser.email === dataFormRequest.approve_request_by ? isSaveEnabled : false}
                                                    onClick={() => onCheckSubmit()}
                                                >
                                                {dataUser.email === dataFormRequest.approve_request_by ? "Approve" : "Submit"}
                                                </Button>
                                            </>
                                        ):null}
                                    </div>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Row>
                    ):
                    <>
                        <div id="footer-modal">
                            <hr className="line-footer"></hr>
                            <Col md={12}>
                                <Button 
                                    className="float-end btn-submit-style" 
                                    color="primary" 
                                    type="button"
                                    onClick={() => validation.submitForm()}
                                >
                                    Update
                                </Button>
                                <Button 
                                    className="float-end btn-cancel" 
                                    color="outline secondary" 
                                    type="button" 
                                    onClick={() => onCancelRequest(false)}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </div>
                    </>
                }   
            </Form>
            </div>
        </React.Fragment>
        );
    };

export default RequestFormNda;